<template>
  <article class="page">
    <h2 class="page__subtitle">Мои курсы</h2>
    <article class="page__courses courses" v-if="courses">
      <course-card v-for="course in courses" :key="course.id" :course="course"></course-card>
    </article>
  </article>
</template>

<script>
import Form from 'vform'
import { mapGetters } from 'vuex'
import CourseCard from "~/components/CourseCard";

export default {
  scrollToTop: false,
  components: {
    CourseCard
  },

  metaInfo () {
    return { title: 'Статистика' }
  },
  data: () => ({

  }),

  computed: mapGetters({
    user: 'auth/user',
    courses: 'courses/courses',
  }),

  created () {
    console.log(this.user);
  },
  methods: {

  },
  beforeMount () {
    this.$store.dispatch('courses/fetchUserCourses');

    this.$store.dispatch('pages/setBreadcrumbs', [
      {
        title: 'Главная',
        route: { name: 'home' },
      },
      {
        title: 'Статистика',
      }
    ]);
  },
  beforeDestroy () {
    this.$store.dispatch('courses/clearCourses');
  }
}
</script>
